import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import AboveFold from './aboveFold';

class MobileTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Below: null,
    };
  }

  componentDidMount() {
    this.setState({
      Below: Loadable({
        loader: () => import('./belowFold'),
        loading() {
          return null;
        },
      }),
    });
  }

  render() {
    const { Below } = this.state;
    const LoadedBelow = !Below ? <div /> : <Below />;
    return (
      <div id="mobileTemplateWrapper">
        <AboveFold />
        {LoadedBelow}
      </div>
    );
  }
}

export default connect()(MobileTemplate);
